export class MemberModel {
  id: string;
  name: string;
  lastname: string;
  email: string;
  roles: string[];
  status: string;
  jobTitle: string;
  title: string;
  language: string;
  focalPoint: boolean;
  sgContact: boolean;
  tiesUser: boolean;
  registeredDate: string;
  username: string;
  crmId: string;

  constructor(member?: Member) {
    this.id = member?.UID;
    this.email = member?.profile?.email;
    this.name = member?.profile?.firstName;
    this.lastname = member?.profile?.lastName;
    this.title = member?.data?.title ? this.parseTitle(member?.data?.title) : member?.profile?.title;
    this.jobTitle = member?.profile?.work?.title || member?.profile?.jobTitle;
    this.language = member?.profile?.language || member?.profile?.locale;
    this.username = member?.profile?.username;
    this.status = member?.status;
    this.registeredDate = member?.registered ? this.parseRegisteredDate(member?.registered) : null;
    this.focalPoint = member?.roles?.includes(MemberRoles.TiesFocalPoint);
    this.sgContact = member?.roles?.includes(MemberRoles.SGContact);
    this.tiesUser = member?.roles?.includes(MemberRoles.TiesUser);
    this.roles = member?.roles?.filter((role) => role && role !== MemberRoles.Default) || [];
    this.crmId = member?.data?.sap?.crm; 
  }

  private parseRegisteredDate(registeredDate: string): string {
    let date = new Date(registeredDate);
    let options: Intl.DateTimeFormatOptions = { day: '2-digit', month: '2-digit', year: 'numeric' };
    return date.toLocaleDateString('de-DE', options);
  }

  private parseTitle(title: string): string {
    const titleMap = {
      '0001': 'Ms',
      '0002': 'Mr',
    };
    return titleMap[title];
  }
}

export enum MemberRoles {
  Default = 'DEFAULT',
  TiesFocalPoint = 'TIES Focal Point',
  SGContact = 'SG Contact',
  TiesUser = 'TIES User',
}

export class MemberResponse {
  results: Member[];
}

class Member {
  UID: string;
  data: Data;
  profile: Profile;
  registered: string;
  roles: string[];
  status: string;
}

class Data {
  title: string;
  sap: Sap;
}

class Sap {
  crm: string;
}

class Profile {
  title?: string;
  jobTitle?: string;
  language?: string;
  lastName: string;
  firstName: string;
  work?: Work;
  locale: string;
  email: string;
  username?: string;
}

class Work {
  title?: string;
}
